import Vue from 'vue'
import router from '../router'
import * as Sentry from '@sentry/vue'
import { runtimeConfig } from '@/util/runtime-config'

const DSN = runtimeConfig('VUE_APP_SENTRY_DSN', '')
if (DSN.length > 0) {
    Sentry.init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        sampleRate: 1.0,
        tracesSampleRate: 0.4,
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracePropagationTargets: [runtimeConfig('VUE_APP_SENTRY_TARGET', 'localhost'), /^\//]
            })
        ]
    })
}
